import React from 'react';
import { Spinner } from 'react-bootstrap';

// Define an interface for the component's props
interface SubmittingSpinnerProps {
  text?: string;
}

const SubmittingSpinner: React.FC<SubmittingSpinnerProps> = ({ text = "Submitting" }) => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <span className="ms-1 mr-2">{text}</span>
      <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
      />
    </div>
  );
};

export default SubmittingSpinner;
